/*
 * @Author: jyy 
 * @Date: 2024-12-23 16:29:30 
 * @Last Modified by: jyy
 * @Last Modified time: 2025-01-14 18:38:50
 */

<template>
    <c-loading :loading="isloading">
        <div class="hotel-scenic-new-list">
            <!-- 头部背景 -->
            <div class="header-bg">
                <img class="top" src="@/assets/list/hotel-scenic-new-list-header-bg.png" alt="">
                <div class="bottom"></div>
            </div>

            <!-- 内容部分 -->
            <div class="content">
                <!-- 标题栏 -->
                <NavigationBar :title="pageTitle"></NavigationBar>
                <div class="list">
                    <mescroll-vue ref="mescroll" class="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
                        <!-- 订酒店，免费赠送景点门票 -->
                        <TipCard></TipCard>
                        <!-- 共N个景点任选 -->
                        <div class="divider" v-if="ticketProductCount">共 {{ ticketProductCount }} 个景点任选</div>
                        <!-- 景点卡片列表 -->
                        <div class="scenic-card-list">
                            <div class="list-item" v-for="(item, index) in ticketProductList" :key="index">
                                <div class="check-box" v-if="pageActionType == 1" @click="selectItem(item)">
                                    <img class="checkicon" v-if="item.scenicSpotId == scenicSpotId" src="@/assets/list/hotel-scenic-new-list-checked.png" alt="">
                                    <img class="checkicon" v-else src="@/assets/list/hotel-scenic-new-list-unchecked.png" alt="">
                                </div>
                                <div class="item-box">
                                    <ScenicCard :item="item" @click="jumpNewDetail"></ScenicCard>
                                </div>
                            </div>
                        </div>
                    </mescroll-vue>
                </div>
                <!-- 底部按钮 -->
                <div class="bottom-btn" v-if="pageActionType == 1" @click="jumpToFillOrder">
                    <div class="btn" :class="{'btn-gray': !scenicSpotId}">确认领取</div>
                </div>
            </div>
        </div>
    </c-loading>
</template>

<script>
import NavigationBar from "./components/navigation-bar.vue";
import MescrollVue from "mescroll.js/mescroll.vue";
import TipCard from "./components/tip-card.vue";
import ScenicCard from "./components/scenic-card.vue";
import nativeApi from "@/utils/nativeApi";
import env from "@/utils/env";
import service from "@/service";
import get from "@/utils/get";

const DEV_MODE = 0;
const MOCK_521003 = require('./mock/r521003.json')
export default {
    components: { NavigationBar, MescrollVue, TipCard, ScenicCard },
    data() {
        return {
            pageActionType: 0,// 页面操作类型: 0: 查看可选景点, 1: 选择景点(默认查看可选景点)
            checkInDate: this.$route.query.checkInDate,// 酒店入住日期 yyyy-MM-dd
            checkOutDate: this.$route.query.checkOutDate,// 酒店离店日期 yyyy-MM-dd
            scenicSpotIds: this.$route.query.scenicSpotIds,// 景点id，多个用逗号拼接
            cityName: this.$route.query.cityName,// 城市名称
            hotelOrderId: this.$route.query.hotelOrderId,// 酒店订单号(选择景点时必传)
            // mescroll实例对象
            mescrollVm: null,
            mescrollDown: { callback: this.downCallback }, //下拉刷新的配置
            mescrollUp: {// 上拉加载的配置
                auto: false,
                callback: this.upCallback, // 上拉回调
                page: {
                    size: 20 // 每页数据的数量
                },
                htmlNodata: ""
            },
            isloading: false,
            pageTitle: "可选景点",
            ticketProductCount: 0,// 景点列表数量
            ticketProductList: [],// 景点列表
            scenicSpotId: "",// 选中的景点id
        };
    },
    watch: {},
    computed: {},
    beforeCreate() {
        if (env.isNative) {
            nativeApi.invoke("updateHeaderRightBtn", {
                action: "hide",
                icon: "",
                text: "",
                data: {},
            })
            nativeApi.invoke("setNavigationBarVisible", { value: "0" });
            nativeApi.invoke("setNavigationBarTintColor", { statusBarStyle: "0" });
        }
    },
    created() {
    },
    mounted() {
        const pageActionType = this.$route.query.pageActionType || 0;
        this.pageActionType = pageActionType;
        this.pageTitle = pageActionType == 0 ? '可选景点' : '选择景点';

        // console.log({pageActionType:this.pageActionType,checkInDate:this.checkInDate,checkOutDate:this.checkOutDate,scenicSpotIds:this.scenicSpotIds,cityName:this.cityName,hotelOrderId:this.hotelOrderId,naviBarHidden:this.$route.query.naviBarHidden});

        // 埋点统计:进入列表选择页 
        if (pageActionType == 1) {
            this.eventStatistics("page_enterTicketschooselist", 'view');
        }
    },
    methods: {
        // 获取酒店可选景点列表
        getHotelScenicList(page) {
            const params = {
                checkInDate: this.checkInDate,
                checkOutDate: this.checkOutDate,
                scenicSpotIds: this.scenicSpotIds,
                cityName: this.cityName,
                hotelOrderId: this.hotelOrderId,
                pageNo: page.num,
                pageSize: page.size
            }
            if (DEV_MODE) {// mock数据
                return Promise.resolve(MOCK_521003)
            }
            return service.r521003(params).then((r) => get(r, "res.bd.data"));
        },
        // mescroll组件初始化的回调,可获取到mescroll对象
        mescrollInit(mescroll) {
            this.mescrollVm = mescroll;
        },
        // 下拉刷新(自动执行 page.num=1, 再触发upCallback)
        downCallback() {
            this.mescrollVm.resetUpScroll()
        },
        // 上拉加载
        upCallback(page, mescroll) {
            this.getHotelScenicList(page).then((data) => {
                this.ticketProductCount = data.ticketProductCount || 0;
                if (page.num == 1) {
                    this.ticketProductList = [];
                }
                this.ticketProductList = this.ticketProductList.concat(data.ticketProductList || []);
                this.mescrollVm.endSuccess(this.ticketProductList.length);
            }).catch(err => {
                this.mescrollVm.endSuccess(0, false);
                this.mescrollVm.endErr();
            })
        },
        // 选中景点
        selectItem(item) {
            this.scenicSpotId = item.scenicSpotId == this.scenicSpotId ? "" : item.scenicSpotId;
        },
        // 跳景点详情
        jumpNewDetail(item) {
            this.$page.push({
                url: "/hotel-scenic-new-detail",
                name: "hotel-scenic-new-detail",
                query: { scenicSpotId: item.scenicSpotId },
                params: {},
            })
        },
        // 跳填单页
        jumpToFillOrder() {
            if (this.pageActionType == 1 && this.scenicSpotId) {
                // 埋点统计:点击确认领取
                this.eventStatistics("btn_Ticketschooselist_confirm", 'click');

                const url = `${process.env.VUE_APP_BASE_URL_PAYMENT}/hangban/vue/hltrip/bookV2?analyseSourceEntry=${env.hlsource}&hlsource=${env.hlsource}&hotelOrderId=${this.hotelOrderId}&scenicSpotId=${this.scenicSpotId}`;
                env.isNative ? nativeApi.invoke("createWebView", { url }) : location.href = url;
            }
        },
        // 事件统计
        eventStatistics(eventId, eventType) {
            this.$ha('send', eventType, {
                eventId,
                bizsys: 'h5',
                actId: 'hltrip'
            })
        }
    }
}
</script>

<style lang='scss' scoped>
@import '@/scss/_vars.scss';

.hotel-scenic-new-list {
    width: 375 * $px;
    background-color: #f2f4f7;
    position: fixed;// 禁用ios回弹
    
    .header-bg {
        width: 375 * $px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 0;

        .top {
            width: 375 * $px;
            object-fit: cover;
        }
        .bottom {
            width: 375 * $px;
            flex: 1;
            background-image: linear-gradient(0deg, rgba(194, 222, 255, 0) 0%, rgba(242, 245, 248, 1) 100%);
        }
    }

    .content {
        width: 375 * $px;
        height: 100vh;
        position: fixed;
        top: 0;
        display: flex;
        flex-direction: column;
        .list {
            width: 100%;
            flex: 1;
            position: relative;
            .mescroll {
                position: absolute;
                width: 100%;
                height: 100%;
            }
        }

        .bottom-btn {
            width: 375 * $px;
            height: 64 * $px;
            box-sizing: content-box;
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
            background: #ffffff;
            box-shadow: 0 0 0 0 #ebebeb;
            .btn {
                margin: 8 * $px;
                height: 48 * $px;
                background-color: #1188ff;
                border-radius: 8 * $px;
                font-size: 18 * $px;
                color: #ffffff;
                text-align: center;
                line-height: 48 * $px;
            }

            .btn-gray {
                background-color: rgba(17, 136, 255, 0.6);
                color: rgba(255, 255, 255, 0.6);
            }
        }
    }
}

.divider {
    font-size: 12 * $px;
    color: #587193;
    text-align: center;
    margin: 20 * $px 12 * $px 12 * $px;
    position: relative;

    &::before {
        content: '';
        display: block;
        width: 121 * $px;
        height: .5 * $px;
        transform: scaleX(-1) translateY(-50%);
        background-image: linear-gradient(270deg, rgba(135, 139, 153, 0) 0%, rgba(188, 191, 201, 1) 100%);
        position: absolute;
        left: 0;
        top: 50%;
    }

    &::after {
        content: '';
        display: block;
        width: 121 * $px;
        height: .5 * $px;
        background-image: linear-gradient(270deg, rgba(135, 139, 153, 0) 0%, rgba(188, 191, 201, 1) 100%);
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

.scenic-card-list {
    width: 375 * $px;
    padding: 0 8 * $px;
    box-sizing: border-box;
    .list-item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 8 * $px;
        .check-box {
            flex-shrink: 0;
            padding: 12 * $px 12 * $px 12 * $px 4 * $px;
            .checkicon {
                width: 20 * $px;
                height: 20 * $px;
            }
        }
        .item-box {
            flex: 1;
            overflow: hidden;
        }
    }
}
</style>